module.exports = __webpack_public_path__ + "fontawesome-webfont.a35720c2fed2c7f043bc.woff";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/fonts/fontawesome-webfont.woff?v=4.1.0
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.woff?v=4.1.0
// module chunks = styles